import BasePage from "@Scripts/Pages/BasePage";

export default class ProductDetailPage extends BasePage {
    public static async init() {
        super.init();
        super.setCarouselProducts();

        this.setCarouselGallery();
    }

    private static setCarouselGallery() {
        var $gallery = (<any>window).$(".gallery.carousel");

        (<any>window).$(".for", $gallery).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: ".gallery.carousel .nav",
            responsive: [
                {
                    breakpoint: 1010,
                    settings: {
                        asNavFor: null,
                        centerMode: true,
                        fade: false,
                        centerPadding: "120px",
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        asNavFor: null,
                        centerMode: true,
                        fade: false,
                        centerPadding: "60px",
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        (<any>window).$(".nav", $gallery).slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            asNavFor: ".gallery.carousel .for",
            dots: true,
            infinite: true,
            arrows: false,
            centerMode: true,
            focusOnSelect: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1010,
                    settings: {
                        asNavFor: null,
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 749,
                    settings: {
                        asNavFor: null,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 599,
                    asNavFor: null,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}